import { render, staticRenderFns } from "./Form10StyleOfProceeding.vue?vue&type=template&id=3537b8be&scoped=true"
import script from "./Form10StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form10StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form10StyleOfProceeding.vue?vue&type=style&index=0&id=3537b8be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537b8be",
  null
  
)

export default component.exports